<script lang="ts">
	export let searchText: string;
	export let gradientStyle = '';
</script>

<div
	class="bg-fx-gradient-8 min-w-[300px] rounded-xl flex items-center border border-fx-grey-500 gap-1 p-3 {gradientStyle}"
>
	<img loading="lazy" src={'search.png'} alt="search" class="w-4 h-4" />
	<input
		type="text"
		placeholder="Search Market"
		bind:value={searchText}
		class="w-full text-fx-grey-200 placeholder:text-fx-grey-200 -mb-0.5 focus:outline-none bg-transparent text-sm"
	/>
</div>
